<h1>Home</h1>
<div class="pagewrapper">
    <img src="https://www.ukg.com/themes/custom/ukg_theme/logo.svg" class="ukglogo">
    <div class="itemgroup">
        <div *ngFor = "let item of todoList" class="item" (click)="itemClicked(item)">
            <mat-icon>{{item.icon}}</mat-icon>
            <div class="itemright">
                <span class="header">{{item.title}}</span>
                <span class="description">{{item.description}}</span>
            </div>
        </div>
    </div>
</div>
